<template>
  <div>
    <div class="card p-4">
      <div class="mb-3">
        <div class="row">
          <div class="col-md-6">
            <label>Empresa</label>
            <v-select :options="filterCompanies" label="corporate_name" :reduce="c => c.id" v-model="filterItems.company_id" @input="loadFilterContracts(); loadFilterWorkplaces(); loadFilterItems()" :placeholder="loadingCompanies ? 'Buscando...' : 'Selecione a empresa'"></v-select>
          </div>
          <div class="col-md-6">
            <label>Contrato</label>
            <v-select :options="filterContracts" label="corporate_name" :reduce="c => c.id" v-model="filterItems.contract_id" @input="loadFilterItems()" :placeholder="loadingContracts ? 'Buscando...' : 'Selecione o contrato'" :disabled="loadingContracts"></v-select>
          </div>
          <div class="col-md-6 mt-2">
            <label>Local de Trabalho</label>
            <v-select :options="filterWorkplaces" label="corporate_name" :reduce="w => w.id" v-model="filterItems.work_place_id" @input="loadFilterSublocal(); loadFilterItems()" :placeholder="loadingWorkplaces ? 'Buscando...' : 'Selecione o local de trabalho'" :disabled="loadingWorkplaces"></v-select>
          </div>
          <div class="col-md-6 mt-2">
            <label>Sublocal</label>
            <v-select :options="filterSublocal" label="corporate_name" :reduce="s => s.id" v-model="filterItems.sublocal_id" @input="loadFilterItems()" :placeholder="loadingSublocal ? 'Buscando...' : 'Selecione o sublocal'" :disabled="loadingSublocal"></v-select>
          </div>
          <div class="col-md-6 mt-2">
            <label>Item</label>
            <v-select :options="filterItemsList" label="name" :reduce="it => it.id" v-model="filterItems.item_id" :placeholder="loadingItemsLoading ? 'Buscando...' : 'Selecione o item'" :disabled="loadingItemsLoading"></v-select>
          </div>
          <div class="col-md-3 mt-2">
            <label>Data</label>
            <input class="form-control" type="date" v-model="filterItems.expected_date" />
          </div>
          <div class="col-md-3 mt-2">
            <label>Hora</label>
            <input class="form-control" type="time" v-model="filterItems.expected_time" />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-12 text-right">
            <button type="button" class="btn btn-sm btn-outline-secondary ml-2" style="margin-right: 10px;" @click="resetFilters">LIMPAR</button>
            <button type="button" class="btn btn-sm btn-primary" @click="loadPrevious()" :disabled="loading">FILTRAR</button>
          </div>
        </div>
      </div>

      <vue-good-table v-if="previousItems.length >= 0"
        :columns="tableColumnsPrevious"
        :rows="previousItems"
        :pagination-options="tablePagination"
        :search-options="{ enabled: true, placeholder: 'Buscar..' }"
        styleClass="vgt-table">
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'generated'">
            <span v-if="props.row.generated" class="text-success">Atividade gerada</span>
            <span v-else class="text-danger">Atividade não gerada</span>
          </span>
          <span v-else-if="props.column.field == 'actions'">
            <a class="btn btn-sm btn-outline-secondary" :href="'/admin/activities/'+props.row.id" target="_blank">Ver Atividade</a>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
        <template slot="pagination-bottom">
          <table-pagination-component :_options="tablePaginationOptionsPrevious" @paginate="paginationPrevious"></table-pagination-component>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import configData from "../../../config.js";
export default {
  props: ['log'],
  mixins: [configData],
  data(){
    return {
      previousItems: [],
      loading: false,
      tablePagination: configData.tablePagination,
      tablePaginationOptionsPrevious: { currentPage: 1, currentPerPage: 10, from:0, to:0, total:null },
      // filter state
      filterItems: {
        company_id: null,
        contract_id: null,
        work_place_id: null,
        sublocal_id: null,
        item_id: null,
        expected_date: '',
        expected_time: ''
      },
      filterCompanies: [],
      filterContracts: [],
      filterWorkplaces: [],
      filterSublocal: [],
      filterItemsList: [],
      // loading flags for dependent selects
      loadingCompanies: false,
      loadingContracts: false,
      loadingWorkplaces: false,
      loadingSublocal: false,
      loadingItemsLoading: false,
      tableColumnsPrevious: [
        { label: 'ID', field: 'id', width: '100px' },
        { label: 'Título', field: 'title' },
        { label: 'Gerado', field: 'generated', width: '160px' },
        { label: 'Ações', field: 'actions', width: '160px' }
      ]
    }
  },
  mounted(){
    if(typeof this.log === 'string') this.log = JSON.parse(this.log);
    this.loadFilterCompanies();
    this.loadPrevious();
  },
  methods:{
    loadFilterCompanies(){
      let _this = this;
      _this.loadingCompanies = true;
      axios.get('/admin/companies').then(res => {
        _this.filterCompanies = res.data;
      }).catch(() => {}).finally(() => { _this.loadingCompanies = false; });
    },

    loadFilterContracts(){
      let _this = this;
      if(!_this.filterItems.company_id) return _this.filterContracts = [];
      _this.loadingContracts = true;
      axios.get('/admin/companycontracts/' + _this.filterItems.company_id + '/search').then(res => {
        _this.filterContracts = res.data.map(r => r.contracts);
      }).catch(() => {}).finally(() => { _this.loadingContracts = false; });
    },

    loadFilterWorkplaces(){
      let _this = this;
      if(!_this.filterItems.company_id) return _this.filterWorkplaces = [];
      _this.loadingWorkplaces = true;
      axios.get('/admin/companyworkplaces/' + _this.filterItems.company_id + '/search').then(res => {
        _this.filterWorkplaces = res.data;
      }).catch(() => {}).finally(() => { _this.loadingWorkplaces = false; });
    },

    loadFilterSublocal(){
      let _this = this;
      if(!_this.filterItems.work_place_id) return _this.filterSublocal = [];
      _this.loadingSublocal = true;
      axios.get('/admin/workplacesublocal/' + _this.filterItems.work_place_id + '/search').then(res => {
        _this.filterSublocal = res.data.map(r => ({ id: r.sublocal_id, corporate_name: r.sublocal_name || (r.sublocal && r.sublocal.corporate_name) }));
      }).catch(() => {}).finally(() => { _this.loadingSublocal = false; });
    },

    loadFilterItems(){
      let _this = this;
      let data = {
        company_id: _this.filterItems.company_id,
        contract_id: _this.filterItems.contract_id,
        work_place_id: _this.filterItems.work_place_id,
        sublocal_id: _this.filterItems.sublocal_id
      };
      _this.loadingItemsLoading = true;
      axios.post('/admin/items/select', data).then(res => {
        _this.filterItemsList = res.data.data || [];
      }).catch(() => {}).finally(() => { _this.loadingItemsLoading = false; });
    },

    resetFilters(){
      this.filterItems = {
        company_id: null,
        contract_id: null,
        work_place_id: null,
        sublocal_id: null,
        item_id: null,
        expected_date: '',
        expected_time: ''
      };
      this.loadPrevious();
    },

    paginationPrevious(page){
      this.tablePaginationOptionsPrevious = {
        currentPage: page.options.currentPage,
        currentPerPage: page.options.currentPerPage,
        from: page.options.from,
        to: page.options.to,
        total: page.options.total
      };
      this.loadPrevious();
    },

    loadPrevious(){
      let _this = this;
      _this.loading = true;
      var body = Object.assign({ log: _this.log.id, page: _this.tablePaginationOptionsPrevious.currentPage, perPage: _this.tablePaginationOptionsPrevious.currentPerPage }, _this.filterItems);
      axios.post('/admin/log/generateactivity/previous', body).then((res) => {
        const { data, total, from, to } = res.data.data;
        _this.tablePaginationOptionsPrevious.total = total;
        _this.tablePaginationOptionsPrevious.from = from;
        _this.tablePaginationOptionsPrevious.to = to;
        _this.previousItems = [...data];
        _this.loading = false;
      }).catch(() => { _this.loading = false; });
    }
  }
}
</script>
